import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { Aritcle } from "@/components/atoms/terms/Article";

/**
 * Props for designated services component
 * @typedef {Object} Props
 * @property {number} articleNumber - The number of the article
 * @property {string} [articleTitle] - The title of the article (optional)
 * @property {string[]} serviceNames - The names of the services
 */
type Props = {
  articleNumber: number;
  articleTitle?: string;
  serviceNames: string[];
};

/**
 * Component to display designated services
 */
export const AritcleDesignatedService: React.FC<Props> = ({
  articleNumber,
  articleTitle = "指定サービス",
  serviceNames,
}: Props) => {
  return (
    <Aritcle articleNumber={articleNumber} articleTitle={articleTitle}>
      <div css={AritcleDesignatedServiceStyle}>
        <Font>
          <span>Mikatano ID</span>
          利用規約及び本特約が適用される指定サービスは、次の各号に定めるとおりとします。
        </Font>
        <ol>
          {serviceNames.map((serviceName, i) => {
            return <li key={i}>{serviceName}</li>;
          })}
        </ol>
      </div>
    </Aritcle>
  );
};

const AritcleDesignatedServiceStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
